import jq from "jquery";
import store from "@/store";
export default {
  // 默认请求
  requestDefault: function (url, params, type, dataType) {
    return jq.ajax({
      type: type ? type : 'post',
      url: process.env.VUE_APP_API_PREFIX + url,
      data: params,
      dataType: dataType ? dataType : 'json'
    });
  },
  requestWithToken: function (url, params, type, dataType,headers) {
    var me = this;
    if (!headers) headers = {}
    return new Promise((resolve, reject) => {

      let time = new Date().getTime();
      var token = window.localStorage.getItem("fz-share-accessToken");
      var expiresIn = window.localStorage.getItem("fz-share-expiresIn");
      var tokenType = window.localStorage.getItem("fz-share-tokenType");
      let tokenTime = window.localStorage.getItem("fz-share-tokenTime");

      if (!!params && Object.prototype.hasOwnProperty.call(params, "isLogin") && params.isLogin) {
        // 登录
        return this.getToken(params).then((data) => {
          console.log("获取token");
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: data.token_type + " " + data.access_token,
              Version: process.env.VUE_APP_VERSION,
              ...headers
            },
            data: params,
            dataType: dataType ? dataType : 'json',
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            }
          });
        });
      } else if (!!token && !!tokenType && !!expiresIn && !!tokenTime) {
        // 有token时，先判断token是否过期
        if ((time - parseInt(tokenTime)) > (parseInt(expiresIn) - 5) * 1000) {
          // token过期，就先刷新token，然后请求数据接口
          console.log("刷新token");
          return this.refreshToken().then((data) => {
            jq.ajax({
              type: type ? type : 'post',
              url: process.env.VUE_APP_API_PREFIX + url,
              headers: {
                Authorization: data.token_type + " " + data.access_token,
                Version: process.env.VUE_APP_VERSION,
                ...headers
              },
              data: params,
              dataType: dataType ? dataType : 'json',
              success: function (res) {
                resolve(res);
              },
              error: function (err) {
                reject(err);
              }
            });
          });
        } else {
          // token 没过期
          console.log("缓存token");
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: tokenType + " " + token,
              Version: process.env.VUE_APP_VERSION,
              ...headers
            },
            data: params,
            dataType: dataType ? dataType : 'json',
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              if (err.responseJSON.code == 401 || err.responseJSON.code == '401') {
                window.localStorage.removeItem("fz-share-userInfo");
                window.localStorage.removeItem("fz-share-accessToken");
                window.localStorage.removeItem("fz-share-refreshToken");
                window.localStorage.removeItem("fz-share-expiresIn");
                window.localStorage.removeItem("fz-share-tokenType");
                window.localStorage.removeItem("fz-share-tokenTime");
                me.getToken(params).then((data) => {
                  me.requestWithToken(url, params, type, dataType,headers);
                });
              } else {
                reject(err);
              }
            }
          });
        }
      } else {
        // 先获取token，然后请求数据接口
        return this.getToken(null).then((data) => {
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: data.token_type + " " + data.access_token,
              Version: process.env.VUE_APP_VERSION,
              ...headers
            },
            data: params,
            dataType: dataType ? dataType : 'json',
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            }
          });
        }).catch(err => {
          reject(err);
        });
      }
    });
  },
  requestWithToken2: function (url, params, type, dataType, obj, headers, processFun) {
    var me = this;
    if (!obj) obj = {}
    if (!headers) headers = {}
    let xhr = {};
    if (processFun) {
      xhr = {
        xhr: me.xhrOnProgress(processFun),
      }
    }

    return new Promise((resolve, reject) => {

      let time = new Date().getTime();
      var token = window.localStorage.getItem("fz-share-accessToken");
      var expiresIn = window.localStorage.getItem("fz-share-expiresIn");
      var tokenType = window.localStorage.getItem("fz-share-tokenType");
      let tokenTime = window.localStorage.getItem("fz-share-tokenTime");

      if (!!token && !!tokenType && !!expiresIn && !!tokenTime) {
        // 有token时，先判断token是否过期
        if ((time - parseInt(tokenTime)) > (parseInt(expiresIn) - 5) * 1000) {
          // token过期，就先刷新token，然后请求数据接口
          console.log("刷新token");
          return this.refreshToken().then((data) => {
            jq.ajax({
              type: type ? type : 'post',
              url: process.env.VUE_APP_API_PREFIX + url,
              headers: {
                Authorization: data.token_type + " " + data.access_token,
                Version: process.env.VUE_APP_VERSION,
                ...headers,
              },
              ...xhr,
              data: params,
              dataType: dataType ? dataType : 'json',
              ...obj,
              success: function (res) {
                resolve(res);
              },
              error: function (err) {
                reject(err);
              }
            });
          });
        } else {
          // token 没过期
          console.log("缓存token");
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: tokenType + " " + token,
              Version: process.env.VUE_APP_VERSION,
              ...headers,
            },
            ...xhr,
            data: params,
            dataType: dataType ? dataType : 'json',
            ...obj,
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              if (err.responseJSON.code == 401 || err.responseJSON.code == '401') {
                window.localStorage.removeItem("fz-share-userInfo");
                window.localStorage.removeItem("fz-share-accessToken");
                window.localStorage.removeItem("fz-share-refreshToken");
                window.localStorage.removeItem("fz-share-expiresIn");
                window.localStorage.removeItem("fz-share-tokenType");
                window.localStorage.removeItem("fz-share-tokenTime");
                me.getToken(params).then((data) => {
                  me.requestWithToken(url, params, type, dataType);
                });
              } else {
                reject(err);
              }
            }
          });
        }
      } else {
        // 先获取token，然后请求数据接口
        return this.getToken(null).then((data) => {
          jq.ajax({
            type: type ? type : 'post',
            url: process.env.VUE_APP_API_PREFIX + url,
            headers: {
              Authorization: data.token_type + " " + data.access_token,
              Version: process.env.VUE_APP_VERSION,
              ...headers,
            },
            ...xhr,
            data: params,
            dataType: dataType ? dataType : 'json',
            ...obj,
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            }
          });
        }).catch(err => {
          reject(err);
        });
      }
    });
  },
  getToken: function (data) {
    return new Promise((resolve, reject) => {
      return store.dispatch("app/GetToken", data).then(res => {
        resolve(res)
      });
    });
  },
  refreshToken: function () {
    return new Promise((resolve, reject) => {
      return store.dispatch("app/RefreshToken").then(res => {
        resolve(res)
      });
    });
  },
  // 获取上传进度
  xhrOnProgress(fun) {
    let me = this;
    me.xhrOnProgress.onprogress = fun; //绑定监听
    //使用闭包实现监听绑
    return function () {
      //通过$.ajaxSettings.xhr();获得XMLHttpRequest对象
      var xhr = jq.ajaxSettings.xhr();
      //判断监听函数是否为函数
      if (typeof me.xhrOnProgress.onprogress !== 'function')
        return xhr;
      //如果有监听函数并且xhr对象支持绑定时就把监听函数绑定上去
      if (me.xhrOnProgress.onprogress && xhr.upload) {
        xhr.upload.onprogress = me.xhrOnProgress.onprogress;
      }
      return xhr;
    }
  },
}